import { toast } from 'react-toastify';
import axios from 'axios';
import * as types from '../constants/actionTypes';
import { request } from '../helpers/axiosRequest';

export const API = axios.create({ baseURL: process.env.REACT_APP_API_URL });

// Add Package
export const addPackage = (data, navigate) => async (dispatch) => {
  try {
    dispatch({ type: types.CREATE_PACKAGE_ATTEMPT });
    const res = await request({
      url: `${process.env.REACT_APP_API_URL}/package/addNew`,
      auth: true,
      method: 'POST',
      data
    });
    toast.success('Package Added Successsully', {
      position: 'top-center',
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      draggable: true,
      progress: undefined
    });

    dispatch({
      type: types.CREATE_PACKAGE_SUCCESS,
      payload: { ...data }
    });

    setTimeout(() => {
      navigate('/dashboard/packages');
    }, 2000);
  } catch (err) {
    dispatch({ type: types.CREATE_PACKAGE_FAIL, payload: err });
    toast.error('Error: Unable to add package (Package with slug may exist)', {
      position: 'top-center',
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      draggable: true,
      progress: undefined
    });
    throw err;
  }
};

// Get Single Package
export const singlePackage = (id) => async (dispatch) => {
  dispatch({ type: types.SINGLE_PACKAGE_ATTEMPT });
  try {
    const res = await request({
      url: `${process.env.REACT_APP_API_URL}/package/get-by-id/${id}`,
      auth: true,
      method: 'GET'
    });

    dispatch({
      type: types.SINGLE_PACKAGE_SUCCESS,
      payload: res.data
    });
  } catch (err) {
    dispatch({ type: types.SINGLE_PACKAGE_FAIL, payload: err });
    throw err;
  }
};

// Get All Categories
export const getAllCategories = () => async (dispatch) => {
  dispatch({ type: types.GET_CATEGORY_ATTEMPT });
  try {
    const res = await request({
      url: `${process.env.REACT_APP_API_URL}/package/get-all`,
      auth: true,
      method: 'GET'
    });

    dispatch({
      type: types.GET_CATEGORY_SUCCESS,
      payload: res.data
    });
  } catch (err) {
    dispatch({ type: types.GET_CATEGORY_FAIL, payload: err });
    throw err;
  }
};

// Upadate Package
export const updatePackage = (data, navigate) => async (dispatch) => {
  try {
    dispatch({ type: types.UPDATE_PACAKGE_ATTEMPT });
    const res = await request({
      url: `${process.env.REACT_APP_API_URL}/package/update-by-id`,
      auth: true,
      method: 'PUT',
      data
    });
    dispatch({
      type: types.UPDATE_PACAKGE_SUCCESS,
      payload: { ...data }
    });
    toast.success('Package Updated Successsully', {
      position: 'top-center',
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      draggable: true,
      progress: undefined
    });
    setTimeout(() => {
      navigate('/dashboard/packages');
    }, 2000);
  } catch (err) {
    dispatch({ type: types.UPDATE_PACAKGE_FAIL, payload: err });
    toast.error('Error: Unable to update package.', {
      position: 'top-center',
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      draggable: true,
      progress: undefined
    });
    throw err;
  }
};

// Delete Package
export const deletePackage = (id) => async (dispatch) => {
  try {
    dispatch({ type: types.DELETE_PACAKGE_ATTEMPT });
    const res = await request({
      method: 'POST',
      auth: true,
      url: `${process.env.REACT_APP_API_URL}/package/delete-by-id`,
      data: { id }
    });

    toast.success('Package Deleted Successsully', {
      position: 'top-center',
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      draggable: true,
      progress: undefined
    });
    setTimeout(() => {
      window.location.href = '/dashboard/packages';
    }, 1000);
    dispatch({ type: types.DELETE_PACAKGE_SUCCESS, payload: {} });
  } catch (err) {
    toast.error('Error: Unable to Delete this Package', {
      position: 'top-center',
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      draggable: true,
      progress: undefined
    });
    dispatch({ type: types.DELETE_PACAKGE_FAIL, payload: err });
    throw new Error(err);
  }
};
